import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9c7a33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 mt-4 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Snabbtåg:"),
    /*#__PURE__*/_createTextVNode(" TGV InOui, Ouigo")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Regionaltåg:"),
    /*#__PURE__*/_createTextVNode(" TER")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Nattåg:"),
    /*#__PURE__*/_createTextVNode(" Intercités de Nuit")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resebokning:"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.sncf-connect.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "sncf-connect.com")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Res när:"),
    /*#__PURE__*/_createTextVNode(" Våren och tidig höst erbjuder bäst väder utan trängsel. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Res billigt:"),
    /*#__PURE__*/_createTextVNode(" Ouigo-tågen är lågprisalternativ till TGV. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Språk:"),
    /*#__PURE__*/_createTextVNode(" Fransmän uppskattar när du försöker med lite franska! ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Mat:"),
    /*#__PURE__*/_createTextVNode(" Picknick med baguette och ost är både billig och ikonisk. ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.sncf-connect.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "SNCF Connect")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.interrail.eu/en/plan-your-trip/trip-ideas/france",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Interrail – Frankrike")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.oui.sncf",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "OUI.sncf")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.rome2rio.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Rome2Rio")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'FranceGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).franceGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Frankrike",
      maxHeight: "60vh",
      backgroundImageClass: "background-france"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Upptäck Frankrike med tåg" }, {
            default: _withCtx(() => [
              _createTextVNode(" Frankrike är en tågresenärs dröm, med ett av Europas mest utvecklade tågnät. Från Alpernas glaciärer till Provence lavendelfält, via Paris och Atlantkusten, når du mängder av upplevelser på bara några timmar. Det är enkelt, bekvämt och kulturellt rikt - perfekt för både förstagångsresenären och livsnjutaren. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Frankrike" }, {
            default: _withCtx(() => [
              _createTextVNode(" Frankrike har ett omfattande nät av höghastighetståg (TGV), regionaltåg (TER) och internationella förbindelser. Interrailkort gäller på nästan alla linjer, men många snabbtåg kräver platsreservation. "),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(ListCard, {
            title: "Förslag på tågrutter i Frankrike",
            items: [
					{
						title: 'Vinresa 🍷',
						description:
							'Alsace → Bourgogne → Rhône → Provence → Bordeaux → Loire → Paris → Champagne',
						link: '/guider/destinationer/frankrike/vinresa',
					},
					{
						title: 'Klassisk Frankrikerutt',
						description: 'Paris → Lyon → Marseille → Nice',
						link: '',
					},
					{
						title: 'Atlantkusten',
						description: 'Bordeaux → Biarritz → Bayonne → Hendaye',
						link: '',
					},
					{
						title: 'Alpina äventyr',
						description: 'Annecy → Grenoble → Chamonix',
						link: '',
					},
				]
          }),
          _createVNode(GridCard, {
            title: "Destinationer i Frankrike",
            items: [
					{
						title: 'Paris',
						image: '🗼',
						description:
							'Kärlekens stad med kultur, historia och kulinariska höjdpunkter.',
						link: '/guider/destinationer/frankrike/paris',
					},
					{
						title: 'Bourgogne',
						image: '🍷',
						description:
							'En vindröm fylld av små byar och världskänt pinot noir.',
						link: '/guider/destinationer/frankrike/bourgogne',
					},
					{
						title: 'Alsace',
						image: '🏘️',
						description:
							'Tyska korsvirkeshus, franska viner och sagolika byar.',
						link: '/guider/destinationer/frankrike/alsace',
					},
					{
						title: 'Provence',
						image: '🌻',
						description:
							'Lavendelfält, medeltida byar och färgstarka marknader.',
						link: '/guider/destinationer/frankrike/provence',
					},
					{
						title: 'Franska Rivieran',
						image: '🌊',
						description: 'Nice, Cannes, Monaco – lyx och sol längs Medelhavet.',
						link: '/guider/destinationer/frankrike/rivieran',
					},
					{
						title: 'Loiredalen',
						image: '🏰',
						description: 'Sagolika slott längs Loirens gröna dalgång.',
						link: '/guider/destinationer/frankrike/loire',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(TextBlock, { header: "Tips för tågluffare i Frankrike" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resurser" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})